import {
  createStyles,
  makeStyles,
  Theme,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { PropsWithChildren } from 'react';

import Button from 'src/legacy/components/Button';
import { BackIcon } from 'src/legacy/components/Icons';
import { LoadingWrapper } from 'src/legacy/components/Loading';
import { OnboardingPageLayout } from 'src/legacy/components/Onboarding';
import { OnboardingFormCard } from 'src/legacy/components/Onboarding/OnboardingFormCard';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backButton: {
      position: 'fixed',

      '&:hover': {
        backgroundColor: 'transparent',
      },
      [theme.breakpoints.up('sm')]: {
        top: theme.spacing(6.25),
        left: theme.spacing(7.5),
      },
      [theme.breakpoints.down('xs')]: {
        top: theme.spacing(2.5),
        left: theme.spacing(2),
      },
    },
  }),
);

interface LegacyOnboardingPageLayoutProps {
  isFirstStep: boolean;
  isLoading: boolean;
  onClickBack: () => void;
}

export const LegacyOnboardingPageLayout = ({
  isFirstStep,
  isLoading,
  onClickBack,
  children,
}: PropsWithChildren<LegacyOnboardingPageLayoutProps>) => {
  const classes = useStyles();
  const theme = useTheme();
  const isNonMobileWindow = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <OnboardingPageLayout>
      <LoadingWrapper
        hideContentWhileLoading
        isLoading={isLoading}
        color={isNonMobileWindow ? 'white' : undefined}
      >
        {!isFirstStep && (
          <Button
            data-testid="onboarding-back-btn"
            htmlId="onboarding-back-btn"
            className={classes.backButton}
            startIcon={<BackIcon style={{ fontSize: 10 }} />}
            onClick={onClickBack}
          >
            <BaseTypography fontType="13Medium">Back</BaseTypography>
          </Button>
        )}
        <OnboardingFormCard>{children}</OnboardingFormCard>
      </LoadingWrapper>
    </OnboardingPageLayout>
  );
};
